import * as React from "react";
import useNotification from "./useNotification";

function Notification() {

	const { notification, removeNotification } = useNotification();

	// Targets both the third-party widget container and the lightweight "Live Chat Facade" button
	// shown before the real widget loads - only one of the two is normally present at a time.
	function hideLiveChat() {
		document.querySelectorAll("#chat-widget-container, .c-live-chat-facade").forEach((element) => {
			element.setAttribute("hidden", "true");
		});
	}

	function showLiveChat() {
		document.querySelectorAll("#chat-widget-container, .c-live-chat-facade").forEach((element) => {
			element.removeAttribute("hidden");
		});
	}

	function handleCloseNotification() {
		removeNotification();
		showLiveChat();
	}

	React.useEffect(() => {
		if (!notification) {
			return;
		}

		hideLiveChat();

		const autoDismissMilliseconds = notification.autoDismissMilliseconds ?? 5000;
		if (!autoDismissMilliseconds) {
			return;
		}

		const timeoutId = setTimeout(() => {
			handleCloseNotification();
		}, autoDismissMilliseconds);

		return () => clearTimeout(timeoutId);
	}, [notification]);

	if(!notification) {
		return null;
	}

	return (
		<div className="c-alert-message--toast-container">
			<div className={`c-alert-message c-alert-message--${notification.type}`}>
			<button type="button" className="c-alert-message__close" onClick={handleCloseNotification}>
							<svg viewBox="0 0 24 24" className="c-alert-message__close-icon" width={24} height={24}>
								<path d="M18.984 6.422l-5.578 5.578 5.578 5.578-1.406 1.406-5.578-5.578-5.578 5.578-1.406-1.406 5.578-5.578-5.578-5.578 1.406-1.406 5.578 5.578 5.578-5.578z" fill="currentColor"></path>
							</svg>
							<span className="u-visuallyhidden">Close notification</span>
						</button>
			{notification.headline}
			<span>{notification.message}</span>
				</div>
		</div>
	);
}

export default Notification;
